import { render, staticRenderFns } from "./CustomerCardDetail.vue?vue&type=template&id=2ed38afd&scoped=true"
import script from "./CustomerCardDetail.vue?vue&type=script&lang=js"
export * from "./CustomerCardDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerCardDetail.vue?vue&type=style&index=0&id=2ed38afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed38afd",
  null
  
)

export default component.exports